import { render, staticRenderFns } from "./customSegment.vue?vue&type=template&id=342dbe79&scoped=true&"
import script from "./customSegment.vue?vue&type=script&lang=js&"
export * from "./customSegment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342dbe79",
  null
  
)

export default component.exports